import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'skipPrimitives'
})
export class SkipPrimitivesPipe implements PipeTransform {

  transform(value?: any, args?: any): any {
    const isValueValid = !!value && !['undefined', 'null', 'NaN'].some(val => val === value);
    return isValueValid ? value : '';
  }

}
